import {styled} from "@mui/material";

export const NotificationViewContainer = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
        width: '100%',
        paddingTop: '1rem',
    }
});

export const NotificationViewTitle = styled('div')(() => {
    return {
        display: 'flex',
        alignItems: 'start',
        flexDirection: 'column',
        width: '100%',
        paddingRight: '2rem',

        '& img' : {
            rotate: '-270deg'
        },
    }
});

export const NotificationViewTitleContent = styled('div')(() => {
    return {
        display: 'flex',
        alignItems: 'start',
    }
});

export const NotificationViewTitleItem = styled('div')(() => {
    return {
        display: 'flex',
        alignItems: 'start',
        flexDirection: 'column',
    }
});

export const NotificationViewBody = styled('div')(() => {
    return {
        width: '100%',
        textOverflow: 'ellipsis',
        display: 'inline-block',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        padding: '2rem',
        background: '#fff',
        borderRadius: '0.5rem',
        height: '100%'
    }
});
